import React from "react"
import propTypes from "prop-types"
import ReactSelect from "react-select"
import Loader from "react-loader-spinner"
import ScrollArea from "react-scrollbar"
import "./styles.scss"

import Button from "../../../../components/Button"

import iconClock from "./images/icon-update.svg"
import iconHandshake from "./images/icon-handshake.svg"
import iconThumbUp from "./images/icon-thumb-up.svg"

class Messages extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filterValue: "",
      messagesState: {}
    }
  }

  componentDidMount() {
    const { filterValue } = this.props

    this.setMessagesState()

    this.setState({ filterValue })
  }

  componentDidUpdate(prevProps) {
    const { filterValue, messages } = this.props

    if (prevProps.messages !== messages) {
      this.setMessagesState()

      this.setState({ filterValue })
    }
  }

  setMessagesState = () => {
    const { messages } = this.props

    const messagesState = {}

    messages.map(action => {
      messagesState[action.id] = false

      return null
    })

    this.setState({ messagesState })
  }

  toggleContent = (id, state) => {
    const { messagesState } = this.state

    this.setState({
      messagesState: {
        ...messagesState,
        [id]: state
      }
    })
  }

  onChange = value => {
    const { onFilterChange } = this.props

    onFilterChange(value.value)

    this.setState({ filterValue: value.value })
  }

  render() {
    const {
      className,
      messages,
      messagesTitle,
      loading,
      isParticipant,
      filterOptions,
      onToggleEndorsement,
      onArchiveSuggestions,
      endorsementLoading,
      archiveSuggestionsLoading
    } = this.props
    const { messagesState, filterValue } = this.state

    let helpRequest

    messages.map(message => {
      if (message.type === "help-request") {
        helpRequest = message
      }

      return null
    })

    return (
      <div className={["messages", className].join(" ")}>
        <div className="messages_header">
          <div className="messages_header_item">
            {!!messagesTitle && (
              <div className="messages_title">{messagesTitle}</div>
            )}
          </div>

          {!!filterOptions.length && (
            <div className="messages_header_item">
              <ReactSelect
                name="messages-filter"
                inputId="messages-filter"
                classNamePrefix="messages_filter"
                placeholder="Filter"
                options={filterOptions}
                isSearchable={false}
                onChange={this.onChange}
                value={filterOptions.filter(
                  option => option.value === filterValue
                )}
              />
            </div>
          )}
        </div>

        <div className="messages_list">
          {loading ? (
            <Loader
              type="TailSpin"
              color="#0c4632"
              height={80}
              width={80}
              className="loader"
            />
          ) : (
            <ScrollArea
              className="messages_list_scrollarea"
              horizontal={false}
              smoothScrolling
            >
              <>
                {!messages.length && (
                  <div className="messages_list_no-items">
                    There are 0 items to display
                  </div>
                )}

                {messages.map(item => {
                  let createdAt
                  const buttonText = item.buttonText || "View"

                  if (item.createdAt) {
                    const year = item.createdAt.slice(0, 4)
                    const month = item.createdAt.slice(5, 7)
                    const day = item.createdAt.slice(8, 10)
                    createdAt = `${year}/${month}/${day}`
                  } else {
                    createdAt = ""
                  }

                  return (
                    <div
                      key={`messages-list-item-${item.id}`}
                      className={`messages_list_item messages_list_item--${item.type}`}
                    >
                      <div className="messages_list_item_header">
                        <div className="messages_list_item_header_item">
                          <div className="messages_list_item_header_avatar">
                            {(item.type === "help-request" ||
                              item.type === "activity") && (
                              <>
                                {item.iconDesc === "clock" && (
                                  <img src={iconClock} alt="message icon" />
                                )}
                                {item.iconDesc === "handshake" && (
                                  <img src={iconHandshake} alt="message icon" />
                                )}
                                {!item.iconDesc && (
                                  <div className="messages_list_item_header_avatar_no-image" />
                                )}
                              </>
                            )}

                            {item.type === "suggestion" && (
                              <div className="messages_list_item_header_avatar_no-image">
                                {item.firstName.slice(0, 1)}
                              </div>
                            )}

                            {!!item.endorsements && item.type === "suggestion" && (
                              <div className="messages_list_item_endorsements messages_list_item_header_avatar_endorsements">
                                <div className="messages_list_item_endorsements_icon">
                                  <img
                                    src={iconThumbUp}
                                    alt="endorsements icon"
                                  />
                                  <span>+{item.endorsements}</span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="messages_list_item_header_info">
                            <div className="messages_list_item_header_title">
                              {item.title}{" "}
                              <span>
                                {item.createdAtDisplay
                                  ? item.createdAtDisplay
                                  : createdAt}
                              </span>
                            </div>
                            {!!item.subtitle && (
                              <div className="messages_list_item_header_description">
                                {item.subtitle}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="messages_list_item_header_item">
                          <button
                            onClick={() => {
                              this.toggleContent(
                                item.id,
                                !messagesState[item.id]
                              )
                            }}
                            type="button"
                            className="messages_list_item_view"
                          >
                            <span>{buttonText}</span>
                          </button>
                        </div>
                      </div>

                      {messagesState[item.id] && (
                        <div className="messages_list_item_body">
                          <div className="messages_list_item_body_title">
                            support request
                          </div>
                          <div className="messages_list_item_body_content">
                            {item.content}
                          </div>

                          <div className="messages_list_item_btns">
                            <Button
                              button={{
                                type: "button",
                                disabled:
                                  archiveSuggestionsLoading ||
                                  item.type !== "help-request" ||
                                  !isParticipant
                              }}
                              onClick={() => {
                                onArchiveSuggestions(item.id, item.planSection)
                              }}
                              className="btn--cancel-light btn--width-md btn--height-sm btn--font-size-sm"
                            >
                              Archive
                            </Button>

                            {item.type === "suggestion" && (
                              <div className="messages_list_item_endorsements messages_list_item_body_endorsements">
                                <div className="messages_list_item_endorsements_text">
                                  Endorsements
                                </div>
                                <button
                                  onClick={() => {
                                    onToggleEndorsement(item.id)
                                  }}
                                  disabled={endorsementLoading}
                                  type="button"
                                  className="messages_list_item_endorsements_icon messages_list_item_endorsements_icon--button"
                                >
                                  <img
                                    src={iconThumbUp}
                                    alt="endorsements icon"
                                  />

                                  {!!item.endorsements && (
                                    <span>+{item.endorsements}</span>
                                  )}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
              </>
            </ScrollArea>
          )}
        </div>

        {isParticipant && helpRequest && (
          <div className="messages_footer">
            <button
              onClick={() => {
                onArchiveSuggestions(helpRequest.id, helpRequest.planSection)
              }}
              type="button"
              className="messages_archive"
            >
              Archive
            </button>
          </div>
        )}
      </div>
    )
  }
}

Messages.defaultProps = {
  className: "",
  messagesTitle: "",
  loading: false,
  filterOptions: [],
  filterValue: "",
  endorsementLoading: false,
  archiveSuggestionsLoading: false,
  onFilterChange: () => {},
  onToggleEndorsement: () => {},
  onArchiveSuggestions: () => {}
}

Messages.propTypes = {
  messagesTitle: propTypes.string,
  messages: propTypes.arrayOf(propTypes.shape({})).isRequired,
  filterValue: propTypes.string,
  loading: propTypes.bool,
  isParticipant: propTypes.bool.isRequired,
  className: propTypes.string,
  filterOptions: propTypes.arrayOf(propTypes.shape({})),
  onFilterChange: propTypes.func,
  onToggleEndorsement: propTypes.func,
  onArchiveSuggestions: propTypes.func,
  endorsementLoading: propTypes.bool,
  archiveSuggestionsLoading: propTypes.bool
}

export default Messages
